import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import KYC from "./KYC";
import PersonalDetail from "./PersonalDetail";
import NomineeDetails from "./NomineeDetails";
import { useTranslation } from "react-i18next";
import { decryptFields } from "../../utils/kycStatus";
import { useSelector } from "react-redux";

const ProfileSetting = () => {
  const { t } = useTranslation();
  const { personalDetailsTab, kycTab, nomineeDetailsTab } = t(
    "profileSettingPage.profileSettingTabs"
  );
  const [value, setValue] = React.useState("1");
  const [kycDone, setKycDone] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const kycDetailApiResponse = useSelector(
    (state) => state.kycDetailsSlice.data.data
  );

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (userDetails) {
      const decryptedData = decryptFields(userDetails, [
        "pan",
        // "address",
        // "bank",
      ]);
      if (
        decryptedData.pan === true
        //  && decryptedData.address === true &&
        // decryptedData.bank === true
      ) {
        setKycDone(true);
      }
    }
  }, [kycDetailApiResponse]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "black",
                  },
                }}
              >
                <Tab
                  label={kycTab}
                  value="1"
                  sx={{
                    color: "black",
                    borderBottom: "2px solid transparent", // Default border
                    "&.Mui-selected": {
                      color: "black", // Active tab color
                      borderBottom: "2px solid black", // Active tab border color
                      fontWeight: "bold", // Bold text for active tab
                    },
                  }}
                />
                {kycDone && (
                  <Tab
                    label={personalDetailsTab}
                    value="2"
                    sx={{
                      color: "black",
                      borderBottom: "2px solid transparent", // Default border
                      "&.Mui-selected": {
                        color: "black", // Active tab color
                        borderBottom: "2px solid black", // Active tab border color
                        fontWeight: "bold", // Bold text for active tab
                      },
                    }}
                  />
                )}
                <Tab
                  label={nomineeDetailsTab}
                  value="3"
                  sx={{
                    color: "black",
                    borderBottom: "2px solid transparent", // Default border
                    "&.Mui-selected": {
                      color: "black", // Active tab color
                      borderBottom: "2px solid black", // Active tab border color
                      fontWeight: "bold", // Bold text for active tab
                    },
                  }}
                />
              </TabList>
            </Box>

            <TabPanel value="1">
              <KYC />
            </TabPanel>
            <TabPanel value="2">
              <PersonalDetail />
            </TabPanel>
            <TabPanel value="3">
              <NomineeDetails />
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </div>
  );
};

export default ProfileSetting;
